<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"
            ><li>Accounts</li></a
          >
          <li>&nbsp;>&nbsp;Account Details</li>
        </ul>
         <h2><span style="color:#1A407D;font-size:27px"> MY</span><span style="color:#F19700; font-size:18px; top:12px"> WILL</span></h2>
        <v-card class="center-box">
        <v-img class="checked" height="66px" width="60" :src="require('@/assets/images/checked.png')"> </v-img>
          
          <div class="will-payment-p1">
           <br>
          <span>
          Thank you for opting to Notarize/Register your WILL.</span>
           <br>
           <span>Notarization or registration of WILL may help to mitigate the chances of litigation at a future date.</span>
          </div>
         
          <div class="will-payment-p1">
           <br>
          <span> 
          To notarize/register your WILL please contact your personal advocate.</span>
          
          </div>
          
          <div class="will-payment-p1">
            <br>
            <span>You can upload the notarized/registered copy of your WILL securely in KeepSafe.</span> 
          </div>
          <div class="will-payment-p1">
            <br>
            <span>In case you face any issue, you can write us at support@nimeya.ai. We will be more than happy to assist you.</span>
          </div>
         
            <button class="will-creation-btn" @click="willcreation()">
              PROCEED TO WILL CREATION
            </button>
         
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
export default {
 data: () => ({}),
  methods: {
    willcreation() {
      this.$router.push({ name: 'MemberWillCreation' }).catch(() => {});
    },
    backButton() {
      this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
    },
  },
}
</script>

<style>
.center-box{
 text-align: center;
}
.thank-box{
 margin-top: 10px;
font: normal normal bold 24px/26px Lato;
letter-spacing: 0px;
color: #272727;
opacity: 1;
}
.checked{
margin-top:25px;
margin-left:410px;
}
.will-payment-p1{
padding:0px;
margin-bottom:0px;
 text-align: center;
font: normal normal medium 13px/19px Lato;
letter-spacing: 0.39px;
color: #7D7D7D;
opacity: 1;
}
.will-creation-btn{
  padding:10px 60px 10px 60px;
  background: #051d42;
  border: 1px solid transparent;
  color: #fff;
  transition: 0.3s all ease-in-out;
  margin-top:40px;
  border-radius: 6px;
}

</style>